import { useTrackValidationErrors } from "./useTrackValidationErrors";

interface Params {
  questionName?: string;
  componentName?: string;
  formError: { error?: boolean; message?: string } | undefined;
}

/**
 * Errores de validación de las preguntas que pinta FormBuilder (producto,
 * salud y postpago): `field_invalid` con el nombre del campo y el paso
 * actual. Nunca la respuesta. Las preguntas vistas y contestadas las emiten
 * las pantallas que las dueñan.
 */
export const useFormTracking = ({ questionName, componentName, formError }: Params): void => {
  const field = componentName || questionName || "unknown";
  useTrackValidationErrors({ [field]: formError?.error ? formError.message || "error" : null });
};
